import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseQuery, stringifyQuery } from '@/common/utils/query';

export const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useMemo(() => parseQuery(location.search), [location.search]);
  const queryString = useMemo(() => stringifyQuery(query), [query]);
  const setQuery = useCallback(
    (patch = {}, options = {}) => {
      const nextQuery = options.reset ? {} : parseQuery(location.search);

      for (const key of options.remove || []) {
        delete nextQuery[key];
      }

      for (const [key, value] of Object.entries(patch)) {
        if (value === undefined || value === null || value === '') {
          delete nextQuery[key];
        } else {
          nextQuery[key] = value;
        }
      }

      const search = stringifyQuery(nextQuery);
      navigate(
        {
          pathname: options.pathname || location.pathname,
          search: search ? `?${search}` : '',
          hash: options.hash ?? location.hash,
        },
        {
          replace: options.replace,
        },
      );
    },
    [location.hash, location.pathname, location.search, navigate],
  );

  return [query, setQuery, queryString];
};
